import { render, staticRenderFns } from "./form5_1a.vue?vue&type=template&id=5cd8d93a&scoped=true"
import script from "./form5_1a.vue?vue&type=script&lang=js"
export * from "./form5_1a.vue?vue&type=script&lang=js"
import style0 from "./form5_1a.vue?vue&type=style&index=0&id=5cd8d93a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd8d93a",
  null
  
)

export default component.exports